import { render } from "./ComponentContact.vue?vue&type=template&id=a1ba920c"
import script from "./ComponentContact.vue?vue&type=script&lang=js"
export * from "./ComponentContact.vue?vue&type=script&lang=js"

import "./ComponentContact.vue?vue&type=style&index=0&id=a1ba920c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__